import React from 'react';
import { ORDERED_LIST_KEY } from '@techchange/pm-specs';
import PropTypes from 'prop-types';
import { EditorView } from 'prosemirror-view';
import { useIntl } from 'react-intl';

import { messages } from '../../../../../../_shared/i18n/messages';

import { ToolbarButton } from '../../../Toolbar';
import isListActive from '../../utils/isListActive';
import { toggleOrderedList } from '../commands';

const propTypes = {

	/**
	 * The id of the DOM element where the editor will be injected.
	 */
	editorDomId: PropTypes.string.isRequired,

	/**
	 * The prosemirror editor view object.
	 */
	editorView: PropTypes.instanceOf(EditorView).isRequired,

	/**
	 * The provided toolbar props to adhere to accessibility (a11y)
	 * guidelines for button toolbars.
	 *
	 * See here: https://www.w3.org/WAI/ARIA/apg/patterns/toolbar
	 */
	a11yToolbarProps: PropTypes.shape({

		/**
		 * The tab index value for the button. Only the button with
		 * current focus should have tab index value of 0. All others
		 * should have value of -1.
		 */
		tabIndex: PropTypes.oneOf(['0', '-1']).isRequired,

		/**
		 * Callback function to handle keypress events on the button.
		 */
		onKeyDown: PropTypes.func.isRequired,

	}),

};

const OrderedListButton = (props) => {

	const {
		editorDomId,
		editorView,
		a11yToolbarProps = {},
	} = props;

	const intl = useIntl();

	const orderedListType = editorView.state.schema.nodes[ORDERED_LIST_KEY];
	const active = isListActive(orderedListType, editorView.state);

	const handleOnToggle = () => {

		toggleOrderedList(editorView.state, editorView.dispatch);
		editorView.focus();

	};

	return (
		<ToolbarButton
			id={`${editorDomId}-toolbar-btn-list-ol`}
			active={active}
			icon="fas fa-list-ol"
			title={intl.formatMessage(messages.TC_COMPONENTS_TEXT_EDITOR_ORDERED_LIST_BUTTON_TITLE)}
			onClick={handleOnToggle}
			{...a11yToolbarProps} />
	);

};

OrderedListButton.propTypes = propTypes;

export default OrderedListButton;
